import { FtPortalVersion, StaffPartnerPermissions } from "src/App";

export const showOverride =(permissions: StaffPartnerPermissions)=>FtPortalVersion === "staff" && permissions.hasPolicyOverridePermission;